<template>
  <div class="mainContainer" v-loading="loading" id="sbsPage" style="width: 1200px;">

    <div class="sbsbigtit">手把手教你做资料服务流程</div>
    <div class="sbs-progress">
      <div class="processLeft">
        <div class="numline one">
          <div class="num-tit">
            <div class="yuanNum">01</div>
            <div class="protit">服务申请</div>
          </div>
          <div class="zhuzi"></div>
        </div>
        <div class="numline two">
          <div class="num-tit">
            <div class="yuanNum">02</div>
            <div class="protit">需求沟通</div>
          </div>
          <div class="zhuzi"></div>
        </div>
        <div class="numline three">
          <div class="num-tit">
            <div class="yuanNum">03</div>
            <div class="protit">签订合同</div>
          </div>
          <div class="zhuzi"></div>
        </div>
        <div class="numline fore">
          <div class="num-tit">
            <div class="yuanNum">04</div>
            <div class="protit">实施服务</div>
          </div>
          <div class="zhuzi"></div>
        </div>
        <div class="numline five">
          <div class="num-tit">
            <div class="yuanNum">05</div>
            <div class="protit">服务验收</div>
          </div>
        </div>
      </div>
      <div class="processRight">
        <div class="flowBox">
          <div class="flowTit">
            <div class="flowZx">
              服务申请
            </div>
          </div>
          <div class="flowConts">
            客户留下姓名、手机号、所在地域信息，或直接拨打客服电话：13137703753
          </div>
          <div class="jiantouA"><img src="@/assets/images/TB1vCByqLzO3e4jSZFxXXaP_FXa-52-60.png" /></div>
        </div>
        <div class="flowBox">
          <div class="flowTit">
            <div class="flowZx">
              需求沟通
            </div>
          </div>
          <div class="flowConts">
            平台业务根据客户预留的基本信息电话或面对面沟通需求
          </div>
          <div class="jiantouA"><img src="@/assets/images/TB1vCByqLzO3e4jSZFxXXaP_FXa-52-60.png" /></div>
        </div>
        <div class="flowBox">
          <div class="flowTit">
            <div class="flowZx">
              签订合同
            </div>
          </div>
          <div class="flowConts">
            平台业务就沟通的结果与客户签订服务合同
          </div>
          <div class="jiantouA"><img src="@/assets/images/TB1vCByqLzO3e4jSZFxXXaP_FXa-52-60.png" /></div>
        </div>
        <div class="flowBox">
          <div class="flowTit">
            <div class="flowZx">
              实施服务
            </div>
          </div>
          <div class="flowConts">
            根据合同需求，安排对应的安全技术专家、安全技术人员、职业卫生技术专家实施服务。
          </div>
          <div class="jiantouA"><img src="@/assets/images/TB1vCByqLzO3e4jSZFxXXaP_FXa-52-60.png" /></div>
        </div>
        <div class="flowBox">
          <div class="flowTit">
            <div class="flowZx">
              服务验收
            </div>
          </div>
          <div class="flowConts">
            双方确认实施结果验收确认
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Notice',
    props: ['wjSrc'],
    data() {
      return {
        total: 0,
        list: [],
        params: {
          page: 1,
          rows: 50
        },
        listData: {
          total: 0,
          rows: []
        },
        loading: false
      }
    },
    methods: {

    },
    created: function() {
    },
    watch: {

    }
  }
</script>

<style>
  /* 手把手教你做档案的流程 */
  #sbsPage .sbsbigtit {
    font-size: 28px;
    color: rgb(24, 24, 24);
    line-height: 42px;
    text-align: center;
    padding: 25px 0 25px;
  }
  #sbsPage .sbs-progress{
      display: flex;
      justify-content: space-between;
  }
  #sbsPage .sbs-progress .processLeft{
      width: 168px;
  }
  #sbsPage .sbs-progress .processLeft .numline .num-tit{
      display: flex;
  }
  #sbsPage .sbs-progress .processLeft .numline .num-tit .protit{
      line-height: 50px;
      font-weight: 600;
      padding-left: 15px;
      font-size: 16px;
  }
  #sbsPage .sbs-progress .processLeft .numline .yuanNum{
      color: #fff;
      width: 48px;
      height: 50px;
      border-radius: 50%;
      line-height: 50px;
      background-color: #0d6efd;
      text-align: center;
      font-weight: 600;
      font-style: italic;
  }
  #sbsPage .sbs-progress .processLeft .numline.one .yuanNum{
      background-color: #6ea7fd;
  }
  #sbsPage .sbs-progress .processLeft .numline.two .yuanNum{
      background-color: #5698fd;
  }
  #sbsPage .sbs-progress .processLeft .numline.three .yuanNum{
      background-color: #4890fc;
  }
  #sbsPage .sbs-progress .processLeft .numline.fore .yuanNum{
      background-color: #287dfb;
  }
  #sbsPage .sbs-progress .processLeft .numline.five .yuanNum{
      background-color: #0d6efd;
  }
  #sbsPage .sbs-progress .processLeft .numline .zhuzi{
      width: 4px;
      height: 78px;
      margin-left: 23px;
  }
  #sbsPage .sbs-progress .processLeft .numline.one .zhuzi{
      background-image: linear-gradient(to bottom, #6ea7fd,#5698fd);
  }
  #sbsPage .sbs-progress .processLeft .numline.two .zhuzi{
      background-image: linear-gradient(to bottom, #5698fd,#4890fc);
  }
  #sbsPage .sbs-progress .processLeft .numline.three .zhuzi{
      background-color: #4890fc;
      background-image: linear-gradient(to bottom, #4890fc,#287dfb);
  }
  #sbsPage .sbs-progress .processLeft .numline.fore .zhuzi{
      background-image: linear-gradient(to bottom, #287dfb,#0d6efd);
  }
  #sbsPage .sbs-progress .processLeft .numline.five .zhuzi{
  }
  #sbsPage .sbs-progress .processRight{
      width: 1000px;
  }
  #sbsPage .sbs-progress .processRight .flowBox .flowTit{
      display: inline-block;
      position: relative;
      transition: all .3s ease;
      list-style: none;
      padding: 0;
      margin: 0;
      background: url('/static/images/flow123.png') 0% 0% / 100% 36px no-repeat;
  }
  #sbsPage .sbs-progress .processRight .flowBox .flowTit .flowZx{
      font-size: 14px;
      color: #fff;
      text-align: left;
      padding: 0 24px;
      min-width: 84px;
      line-height: 36px;
      cursor: auto;
  }
  #sbsPage .sbs-progress .processRight .flowBox .flowConts{
      padding: 23px;
      background: #fff;
      border-radius: 3px;
      box-shadow: 0 4px 15px 0 rgb(0 0 0 / 10%);
      margin-bottom: 20px;
      font-size: 14px;
      color: #3d3d3d;
      text-align: left;
      line-height: 24px;
      margin-right: 48px;
  }
  #sbsPage .sbs-progress .processRight .flowBox .jiantouA{
      margin: 11px 0 -25px;
      text-align: center;
  }
  #sbsPage .sbs-progress .processRight .flowBox .jiantouA img{
      width: 26px;
      height: 30px;
  }
  #sbsPage .sbs-progress .processRight .flowBox .flowConts.disflex{
      display: flex;
      justify-content: space-between;
  }
  #sbsPage .sbs-progress .processRight .flowBox .flowConts.disflex .eitem{
      background: #f5f5f6;
      padding: 8px 18px;
      width: 49%;
      font-size: 14px;
      color: #3d3d3d;
      text-align: left;
      line-height: 24px;
  }
  #sbsPage .sbs-progress .processRight .flowBox .flowConts.disflex .eitem .titl{
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #181818;
      line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flow.vue